module.exports = __webpack_public_path__ + "static/image-biersafe-s-c7713644cbb992f10bd8b71e787a1cff.png";